// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type PriceParity20CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const PriceParity20Circle: FC<PriceParity20CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M8.64 12.403H5.517L7.078 8.83l1.563 3.574ZM18.484 12.403H15.36l1.563-3.574 1.562 3.574ZM12.004 5.606a.67.67 0 0 1 .498.206.69.69 0 0 1 .201.501.67.67 0 0 1-.205.499.69.69 0 0 1-.502.2.67.67 0 0 1-.498-.204.69.69 0 0 1-.201-.502.67.67 0 0 1 .205-.498.69.69 0 0 1 .502-.202Z" />
            <path
                d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0Zm-.002 4.2c-.457 0-.867.13-1.23.39-.364.261-.62.6-.767 1.016H5.438v1.407h1.406L4.5 12.403c.013.638.28 1.15.8 1.534.522.384 1.114.576 1.778.576.664 0 1.257-.192 1.777-.576.521-.385.788-.896.801-1.534l-2.344-5.39h2.696c.104.3.27.563.498.79.228.229.491.395.79.499v8.554H4.5v1.407h15v-1.407h-6.797V8.302c.3-.104.563-.27.791-.498.228-.228.394-.492.498-.791h2.695l-2.343 5.39c.013.638.28 1.15.8 1.534.521.384 1.117.576 1.788.576.67 0 1.266-.192 1.787-.576.52-.385.781-.897.781-1.539l-2.344-5.385h1.407V5.6h-4.564a2.077 2.077 0 0 0-.769-1.01 2.07 2.07 0 0 0-1.232-.39Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default PriceParity20Circle;
